import { RestClient } from "./restClient";
import RestResponse from "@/models/client/RestResponse";
import RequestMethod from "@/models/client/RequestMethod";
import { PiiWhitelist } from "@/models/pii/PiiWhitelist";

export type PiiWhitelistServiceType = {
  get: () => RestResponse<PiiWhitelist>;
  addTerm: (term: string) => RestResponse<PiiWhitelist>;
  removeTerm: (normalized: string) => RestResponse<PiiWhitelist>;
};

const piiWhitelistServices = (
  client: RestClient,
  path: string
): PiiWhitelistServiceType => ({
  get: async () => {
    return await client.fetch<PiiWhitelist>(RequestMethod.GET, path);
  },
  addTerm: async (term: string) => {
    return await client.fetch<PiiWhitelist>(RequestMethod.POST, path, { term });
  },
  removeTerm: async (normalized: string) => {
    return await client.fetch<PiiWhitelist>(
      RequestMethod.POST,
      `${path}/remove`,
      { normalized }
    );
  },
});

export default piiWhitelistServices;
